import { useState, useRef, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { setScrollPosition, unsetScrollPosition } from '@Components/Utilities/SandhillsUtility';
import panzoom from 'panzoom';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import translator from '@Components/Utilities/Translator';

const FloorPlan = (props) => {

    const panzoomRef = useRef(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (showModal) {
            let element = document.getElementsByClassName('fpm-content')[0];
            panzoomRef.current = panzoom(element, {
                onTouch: function(e) {
                    return false;
                }
            });
            window.addEventListener('keydown', handleKeyDown);
        } else {
            cleanup();
        }

        return () => {
            if (showModal) {
                cleanup();
            }
        };
    }, [showModal]);

    const cleanup = () => {
        panzoomRef.current?.dispose?.();
        window.removeEventListener('keydown', handleKeyDown);
    };

    const toggleModal = () => {
        if (showModal) {
            unsetScrollPosition();
        } else {
            setScrollPosition();
        }

        setShowModal(showModal => !showModal);
    };

    const handleKeyDown = (event) => {
        if (event.key == 'Escape') {
            unsetScrollPosition();
            setShowModal(false);
        }
    };

    return (
        <div className='listing-floorplan'>
            {props.IsRedesign ? 
                <div className='floorplan-link' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleModal(); } }} onClick={toggleModal}>                
                    {props.DisplayText}
                    <i className='fas fa-external-link-alt listing-floorplan__icon' />
                </div>
                :
                <Button
                    variant='text'
                    size='small'
                    className='listing-floorplan__button'
                    onClick={toggleModal}>
                    <Icon baseClassName='fas' className='fa-image listing-floorplan__icon listing-floorplan__image-icon' />
                    {props.DisplayText}
                    <Icon baseClassName='fas' className='fa-external-link-alt listing-floorplan__icon' />
                </Button>}
            {props.ShowThumb &&
                <LazyLoadImage className='listing-floorplan__thumb' src={props.Url} alt={props.DisplayText} />
            }
            {showModal &&
                <div className='floorplan-modal'>
                    <div className='fpm-overlay' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleModal(); } }} aria-label={translator.translate('sandhills.closepage')} onClick={toggleModal}></div>
                    <div className='fpm-content'>
                        <img className='fpm-img-fs' src={props.Url} alt='floorplan image' />
                    </div>
                    <div className='fpm-close'>
                        <i className='fas fa-window-close fpm-close-icon' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleModal() } }} aria-label={translator.translate('sandhills.open') } onClick={toggleModal}></i>
                    </div>
                </div>}
        </div>
    );
};

export default FloorPlan;